import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Item } from '@/api/model/interfaces';

export default class PackageKS2ItemOdata extends OdataManager<PackageKS2Item> {}
